"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var use_ssr_1 = __importDefault(require("use-ssr"));
var types_1 = require("./types");
var useFetchArgs_1 = __importDefault(require("./useFetchArgs"));
var doFetchArgs_1 = __importDefault(require("./doFetchArgs"));
var utils_1 = require("./utils");
var CACHE_FIRST = types_1.CachePolicies.CACHE_FIRST;
var responseMethods = ['clone', 'error', 'redirect', 'arrayBuffer', 'blob', 'formData', 'json', 'text'];
var makeResponseProxy = function makeResponseProxy() {
  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Proxy(res, {
    get: function get(httpResponse, key) {
      if (responseMethods.includes(key)) return function () {
        return httpResponse.current[key]();
      };
      return (httpResponse.current || {})[key];
    }
  });
};
var cache = new Map();
function useFetch() {
  var _this = this;
  var _useFetchArgs_1$defau = useFetchArgs_1.default.apply(useFetchArgs_1, arguments),
    customOptions = _useFetchArgs_1$defau.customOptions,
    requestInit = _useFetchArgs_1$defau.requestInit,
    defaults = _useFetchArgs_1$defau.defaults,
    dependencies = _useFetchArgs_1$defau.dependencies;
  var initialURL = customOptions.url,
    path = customOptions.path,
    interceptors = customOptions.interceptors,
    timeout = customOptions.timeout,
    retries = customOptions.retries,
    onTimeout = customOptions.onTimeout,
    onAbort = customOptions.onAbort,
    onNewData = customOptions.onNewData,
    perPage = customOptions.perPage,
    cachePolicy = customOptions.cachePolicy,
    cacheLife = customOptions.cacheLife;
  var _use_ssr_1$default = use_ssr_1.default(),
    isServer = _use_ssr_1$default.isServer;
  var controller = react_1.useRef();
  var res = react_1.useRef({});
  var data = react_1.useRef(defaults.data);
  var timedout = react_1.useRef(false);
  var attempts = react_1.useRef(retries);
  var error = react_1.useRef();
  var hasMore = react_1.useRef(true);
  var _react_1$useState = react_1.useState(defaults.loading),
    _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
    loading = _react_1$useState2[0],
    setLoading = _react_1$useState2[1];
  var makeFetch = react_1.useCallback(function (method) {
    var doFetch = function doFetch(routeOrBody, body) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var theController, _yield$doFetchArgs_1$, url, options, requestID, isCached, cachedData, whenCached, age, timer, newData, newRes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isServer) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              // for now, we don't do anything on the server
              controller.current = new AbortController();
              controller.current.signal.onabort = onAbort;
              theController = controller.current;
              _context.next = 7;
              return doFetchArgs_1.default(requestInit, initialURL, path, method, theController, routeOrBody, body, interceptors.request);
            case 7:
              _yield$doFetchArgs_1$ = _context.sent;
              url = _yield$doFetchArgs_1$.url;
              options = _yield$doFetchArgs_1$.options;
              requestID = _yield$doFetchArgs_1$.requestID;
              isCached = cache.has(requestID);
              cachedData = cache.get(requestID);
              if (!(isCached && cachePolicy === CACHE_FIRST)) {
                _context.next = 22;
                break;
              }
              whenCached = cache.get(requestID + ':ts');
              age = Date.now() - whenCached;
              if (!(cacheLife > 0 && age > cacheLife)) {
                _context.next = 21;
                break;
              }
              cache.delete(requestID);
              cache.delete(requestID + ':ts');
              _context.next = 22;
              break;
            case 21:
              return _context.abrupt("return", cachedData);
            case 22:
              if (!(perPage > 0 && !hasMore.current && !error.current)) {
                _context.next = 24;
                break;
              }
              return _context.abrupt("return", data.current);
            case 24:
              setLoading(true);
              error.current = undefined;
              timer = timeout > 0 && setTimeout(function () {
                timedout.current = true;
                theController.abort();
                if (onTimeout) onTimeout();
              }, timeout);
              _context.prev = 27;
              _context.next = 30;
              return fetch(url, options);
            case 30:
              _context.t0 = _context.sent;
              if (_context.t0) {
                _context.next = 33;
                break;
              }
              _context.t0 = {};
            case 33:
              newRes = _context.t0;
              res.current = newRes.clone();
              _context.prev = 35;
              _context.next = 38;
              return newRes.json();
            case 38:
              newData = _context.sent;
              _context.next = 51;
              break;
            case 41:
              _context.prev = 41;
              _context.t1 = _context["catch"](35);
              _context.prev = 43;
              _context.next = 46;
              return newRes.text();
            case 46:
              newData = _context.sent;
              _context.next = 51;
              break;
            case 49:
              _context.prev = 49;
              _context.t2 = _context["catch"](43);
            case 51:
              newData = defaults.data && utils_1.isEmpty(newData) ? defaults.data : newData;
              res.current.data = onNewData(data.current, newData);
              res.current = interceptors.response ? interceptors.response(res.current) : res.current;
              utils_1.invariant('data' in res.current, 'You must have `data` field on the Response returned from your `interceptors.response`');
              data.current = res.current.data;
              if (Array.isArray(data.current) && !!(data.current.length % perPage)) hasMore.current = false;
              if (cachePolicy === CACHE_FIRST) {
                cache.set(requestID, data.current);
                if (cacheLife > 0) cache.set(requestID + ':ts', Date.now());
              }
              _context.next = 66;
              break;
            case 60:
              _context.prev = 60;
              _context.t3 = _context["catch"](27);
              if (!(attempts.current > 0)) {
                _context.next = 64;
                break;
              }
              return _context.abrupt("return", doFetch(routeOrBody, body));
            case 64:
              if (attempts.current < 1 && timedout.current) error.current = {
                name: 'AbortError',
                message: 'Timeout Error'
              };
              if (_context.t3.name !== 'AbortError') error.current = _context.t3;
            case 66:
              _context.prev = 66;
              if (newRes && !newRes.ok && !error.current) error.current = {
                name: newRes.status,
                message: newRes.statusText
              };
              if (attempts.current > 0) attempts.current -= 1;
              timedout.current = false;
              if (timer) clearTimeout(timer);
              controller.current = undefined;
              setLoading(false);
              return _context.finish(66);
            case 74:
              return _context.abrupt("return", data.current);
            case 75:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[27, 60, 66, 74], [35, 41], [43, 49]]);
      }));
    };
    return doFetch;
  }, [initialURL, requestInit, isServer]);
  var post = react_1.useCallback(makeFetch(types_1.HTTPMethod.POST), [makeFetch]);
  var del = react_1.useCallback(makeFetch(types_1.HTTPMethod.DELETE), [makeFetch]);
  var request = {
    get: react_1.useCallback(makeFetch(types_1.HTTPMethod.GET), [makeFetch]),
    post: post,
    patch: react_1.useCallback(makeFetch(types_1.HTTPMethod.PATCH), [makeFetch]),
    put: react_1.useCallback(makeFetch(types_1.HTTPMethod.PUT), [makeFetch]),
    del: del,
    delete: del,
    abort: function abort() {
      return controller.current && controller.current.abort();
    },
    query: function query(_query, variables) {
      return post({
        query: _query,
        variables: variables
      });
    },
    mutate: function mutate(mutation, variables) {
      return post({
        mutation: mutation,
        variables: variables
      });
    },
    loading: loading,
    error: error.current,
    data: data.current
  };
  // onMount/onUpdate
  react_1.useEffect(function () {
    if (dependencies && Array.isArray(dependencies)) {
      var methodName = requestInit.method || types_1.HTTPMethod.GET;
      var methodLower = methodName.toLowerCase();
      var req = request[methodLower];
      req();
    }
  }, dependencies);
  // Cancel any running request when unmounting to avoid updating state after component has unmounted
  // This can happen if a request's promise resolves after component unmounts
  react_1.useEffect(function () {
    return request.abort;
  }, []);
  return Object.assign([request, makeResponseProxy(res), loading, error.current], Object.assign({
    request: request,
    response: makeResponseProxy(res)
  }, request));
}
exports.useFetch = useFetch;
exports.default = useFetch;